export enum RecorderCloseOptions {
  CANCEL = "cancel",
  DELETE = "delete",
}
